<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="relative w-full pr-6">
    <div class="flex pr-3">
      <div class="w-10 basis-10 tablet:w-16 tablet:basis-16">
        <p class="text-center leading-6 text-gray-600 tablet:leading-7">
          {{ itemIndex + 1 }}
        </p>
      </div>
      <div class="flex-1">
        <h3
          v-if="itemData.name"
          class="text-h5 cursor-pointer tablet:line-clamp-4"
          :class="isOpen && 'mb-3 tablet:mb-5'"
          @click="handleClick"
        >
          {{ itemData.name }}
        </h3>
        <div v-show="isOpen">
          <TheRichText
            v-if="itemData.description"
            class="mb-2 text-sm leading-6 text-gray-700 last:mb-0 tablet:line-clamp-6"
            :text="itemData.description"
            :is-html="true"
          />

          <TheNuxtLink
            v-if="itemData.link"
            :id="itemData.link.trackingCode"
            :to="itemData.link.link"
            :title="itemData.link.text"
            class="text-sm font-bold leading-6 text-blue-400 underline"
          >
            {{ itemData.link.text }}
          </TheNuxtLink>
        </div>
      </div>
    </div>
    <button class="absolute right-0 top-0 h-6 w-6" @click="handleClick">
      <IconCaret :direction="isOpen ? 'up' : 'down'" class="h-full w-full" />
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { IItem } from '@/components/Shared/Section/Accordion/02.vue';

  interface IProps {
    itemData: IItem;
    itemIndex: number;
    defaultOpen?: boolean;
  }

  const props = defineProps<IProps>();

  const isOpen = ref<boolean>(props.defaultOpen);

  const handleClick = (): void => {
    isOpen.value = !isOpen.value;
  };
</script>
